import { TranslateService } from '@ngx-translate/core'

export function TranslateLocalIdFactory(translateService: TranslateService): string {
  // Angular's built-in LOCALE_ID for some languages uses a short code
  const languageCodeMapping: { [key: string]: string } = {
    'pl-pl': 'pl',
    'hu-hu': 'hu',
  }
  const lang =
    translateService.getCurrentLang() ||
    translateService.getFallbackLang() ||
    localStorage.getItem('userLanguage') ||
    window.navigator.language ||
    'en-us'
  return languageCodeMapping[lang] ?? lang
}
